export const imageListToLoad = [
  //default image
  ['default', 'images/default.jpg'],

  ['table1', 'images/wooden_table.png'],
  ['table2', 'images/table_te.jpg'],
  ['map1', 'images/map_1.gif'],
  ['map2', 'images/map_te.jpg'],
  ['title', 'images/title.png'],
  ['star', 'images/star.svg'],
  ['icon_check', 'images/icons/icon_check.svg'],
  ['circle1', 'images/hand_drawn_circle_1.svg'],
  ['circle2', 'images/hand_drawn_circle_2.svg'],
  ['circle3', 'images/hand_drawn_circle_3.svg'],
  ['circle4', 'images/hand_drawn_circle_4.svg'],
  ['circle5', 'images/hand_drawn_circle_5.svg'],
  ['circle6', 'images/hand_drawn_circle_6.svg'],
];
